(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid-2"] && !Shopify.designMode) return;
  try {
    
    var article = document.querySelector('.standard-pg-layout') 
    if (article.innerHTML.indexOf('[IMG GRID]') !== -1) {
        var imgGrid = $('#popout');
        var imgGridHtml = imgGrid.html();
        imgGrid.hide();

        var shortCode = 'p:contains("[IMG GRID]")';
      $( shortCode ).before(imgGridHtml);
      $( shortCode ).remove();
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-card-01"] && !Shopify.designMode) return;
  try {
    

// v3.1.0
//Docs at http://simpleweatherjs.com
$(document).ready(function() {
  $.simpleWeather({
    location: 'Colorado Springs, Co',
    unit: 'f',
    success: function(weather) {


      var simplifiedCode;
      var weatherCode = parseInt(weather.code);
    var wind = [23,24];
    var snow = [5,6,7,8,10,13,14,15,16,17,18,35,41,42,43,46];
    var storm = [0,1,2,3,4,37,38,39,45,47];
    var rain = [9,11,12,40];
    var sun = [32,33,34,3200];
    var clouds = [26,27,28];
    var partClouds = [29,30,44];
    var fog = [19,20,21,22];
    var cold = [25];
    var hot = [36];
    var clearNight = [31];


      if (wind.includes(weatherCode)) {
        var simplifiedCode = 'wind';
      } 
      else if (snow.includes(weatherCode)){
      var simplifiedCode = 'snow';
      }
      else if (storm.includes(weatherCode)){
      var simplifiedCode = 'storm';
      }
      else if (rain.includes(weatherCode)){
      var simplifiedCode = 'rain';
      }
      else if (sun.includes(weatherCode)){
      var simplifiedCode = 'sun';
      }
      else if (clouds.includes(weatherCode)){
      var simplifiedCode = 'clouds';
      }
      else if (partClouds.includes(weatherCode)){
      var simplifiedCode = 'partClouds';
      }
      else if (fog.includes(weatherCode)){
      var simplifiedCode = 'fog';
      }
      else if (cold.includes(weatherCode)){
      var simplifiedCode = 'cold';
      }
      else if (hot.includes(weatherCode)){
      var simplifiedCode = 'hot';
      }
      else if (clearNight.includes(weatherCode)){
      var simplifiedCode = 'clearNight';
      }

      html = '<svg class="symbol-'+simplifiedCode+'"><use xlink:href="#symbol-'+simplifiedCode+'"></use></svg> <span class="temp">'+weather.temp+'&deg;'+weather.units.temp+'</span>';
 
      $("#weather").html(html);
    },
    error: function(error) {
      console.log(error);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-card-02"] && !Shopify.designMode) return;
  try {
    

// v3.1.0
//Docs at http://simpleweatherjs.com
$(document).ready(function() {
  $.simpleWeather({
    location: 'Colorado Springs, Co',
    unit: 'f',
    success: function(weather) {


      var simplifiedCode;
      var weatherCode = parseInt(weather.code);
    var wind = [23,24];
    var snow = [5,6,7,8,10,13,14,15,16,17,18,35,41,42,43,46];
    var storm = [0,1,2,3,4,37,38,39,45,47];
    var rain = [9,11,12,40];
    var sun = [32,33,34,3200];
    var clouds = [26,27,28];
    var partClouds = [29,30,44];
    var fog = [19,20,21,22];
    var cold = [25];
    var hot = [36];
    var clearNight = [31];


      if (wind.includes(weatherCode)) {
        var simplifiedCode = 'wind';
      } 
      else if (snow.includes(weatherCode)){
      var simplifiedCode = 'snow';
      }
      else if (storm.includes(weatherCode)){
      var simplifiedCode = 'storm';
      }
      else if (rain.includes(weatherCode)){
      var simplifiedCode = 'rain';
      }
      else if (sun.includes(weatherCode)){
      var simplifiedCode = 'sun';
      }
      else if (clouds.includes(weatherCode)){
      var simplifiedCode = 'clouds';
      }
      else if (partClouds.includes(weatherCode)){
      var simplifiedCode = 'partClouds';
      }
      else if (fog.includes(weatherCode)){
      var simplifiedCode = 'fog';
      }
      else if (cold.includes(weatherCode)){
      var simplifiedCode = 'cold';
      }
      else if (hot.includes(weatherCode)){
      var simplifiedCode = 'hot';
      }
      else if (clearNight.includes(weatherCode)){
      var simplifiedCode = 'clearNight';
      }

      html = '<svg class="symbol-'+simplifiedCode+'"><use xlink:href="#symbol-'+simplifiedCode+'"></use></svg> <span class="temp">'+weather.temp+'&deg;'+weather.units.temp+'</span>';
 
      $("#weather").html(html);
    },
    error: function(error) {
      console.log(error);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
